export const routes = {
    root: '/',
    error: 'error',
    notFound: 'not-found',
    forbidden: 'forbidden',
    home: 'home',
    loginCallback: {
        root: 'login/callback',
    },
    logout: 'logout',
    profile: {
        root: 'profile',
        consents: {
            root: 'consents',
            consentId: ':consentId',
            details: {
                root: ':consentId/details',
            },
        },
    },
    fill: {
        root: 'fill',
        drxId: {
            root: ':drxId',
            coverageSelect: 'coverage-select',
            coverageSubSelect: 'coverage-sub-select',
            onHold: 'on-hold',
            pathSelect: 'path-select',
            pharmacy: {
                root: 'pharmacy',
                offer: ':pharmacyId/:offerId',
            },
            switch: 'switch',
        },
    },
    programs: {
        root: 'programs',
        drugKey: {
            root: ':drugKey',
            terms: {
                root: 'terms',
                pathway: ':pathway',
            },
        },
    },
    order: {
        root: 'order',
        prescriberOrderId: {
            root: ':prescriberOrderId',
            confirmation: 'confirmation',
            renewalStatus: 'renewal-status',
            summary: 'summary',
            details: 'details',
            pharmacy: {
                root: 'pharmacy',
                providerId: ':providerId',
            },
            switch: {
                root: 'switch',
                verify: 'verify',
                options: 'options',
                target: {
                    root: ':targetNdc',
                    confirmation: 'confirmation',
                },
            },
            verify: 'verify',
            verifyPatient: 'verify-patient',
            otherOptions: 'other-options',
        },
    },
    cabinet: {
        root: 'cabinet',
        history: 'history',
    },
    support: 'support',
} as const;
